// References: the papers the programs' methods come from, numbered per program as in the desktop programs' References
// menus. The same numbers appear next to what they are the source for (e.g. "Energy Bands [1]" in Quantum Transport,
// the property boxes of SKFitter, the levels of QTetris).
import { Anchor, Card, Loader, Stack, Text, Title } from "@mantine/core";
import { ErrorBox } from "../components/Errors";
import { PageTitle } from "../components/Layout";
import { useReferences } from "../lib/references";

export function ReferencesPage() {
  const q = useReferences();
  return (
    <Stack>
      <PageTitle title="References" />
      <Text c="dimmed" size="sm">
        The papers the methods are based on, numbered per program. The numbers match the markers next to the methods, e.g.
        {" "}"Energy Bands [1]", and the References menu of the desktop programs.
      </Text>
      {q.isLoading && <Loader size="sm" />}
      <ErrorBox error={q.error} />
      {q.data?.map((s) => (
        <Card withBorder key={s.key} id={`refs-${s.key}`} data-testid={`references-${s.key}`}>
          <Title order={4} mb="sm">{s.program}</Title>
          {s.references.length === 0 && <Text size="sm" c="dimmed">No references yet.</Text>}
          <Stack gap="sm" component="ol" style={{ listStyle: "none", margin: 0, padding: 0 }}>
            {s.references.map((r) => (
              <li key={r.key} id={`ref-${s.key}-${r.number}`} data-testid="reference">
                <Text size="sm">
                  <Text span fw={600}>[{r.number}]</Text> {r.citation}
                  {r.url && <>{" "}<Anchor href={r.url} target="_blank" rel="noopener noreferrer" size="sm">{r.url}</Anchor></>}
                </Text>
                {!!r.used_for?.length && <Text size="xs" c="dimmed">Used for: {r.used_for.join(", ")}</Text>}
              </li>
            ))}
          </Stack>
        </Card>
      ))}
    </Stack>
  );
}
